import { render, staticRenderFns } from "./TicketBookmarkButton.vue?vue&type=template&id=6af26fd2&scoped=true&"
import script from "./TicketBookmarkButton.vue?vue&type=script&lang=ts&"
export * from "./TicketBookmarkButton.vue?vue&type=script&lang=ts&"
import style0 from "./TicketBookmarkButton.vue?vue&type=style&index=0&id=6af26fd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af26fd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6af26fd2')) {
      api.createRecord('6af26fd2', component.options)
    } else {
      api.reload('6af26fd2', component.options)
    }
    module.hot.accept("./TicketBookmarkButton.vue?vue&type=template&id=6af26fd2&scoped=true&", function () {
      api.rerender('6af26fd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ticket/TicketBookmarkButton.vue"
export default component.exports